<div class="dashboard-card">
  <div class="card-content">
    <div class="text-section">
      <h3 class="card-title">{{ title() }}</h3>
      <p class="card-description">{{ description() }}</p>
    </div>
    <div class="icon-section">
      <mat-icon class="card-icon">{{ icon() }}</mat-icon>
      @if (showNotificationDot()) {
        <span class="card-icon-dot" aria-label="New notifications"></span>
      }
    </div>
  </div>
  <div class="card-actions">
    <button class="card-button" (click)="onCardClick()">
      {{ buttonText() }}
      <mat-icon class="button-arrow notranslate" translate="no">chevron_right</mat-icon>
    </button>
  </div>
</div>
